export default (function (key, val) {
  window.localStorage.setItem("__REACT_IMAGE_ANNOTATE_".concat(key), JSON.stringify(val));
});